import React, { useEffect, useState } from "react";

import MoonIcon from '@/shared/icons/MoonIcon';
import SunIcon from '@/shared/icons/SunIcon';
import useLayoutStore from "@/stores/layout/layoutStore";
import mixpanel from '@/utils/mixpanel';

const DDarkModeSelector = React.forwardRef((_props, ref) => {
  const [dark, setDark] = useState(localStorage.getItem("theme") === "dark");
  const setIsDarkMode = useLayoutStore((state) => state.setIsDarkMode);

  const darkModeHandler = () => {
    mixpanel.track('Dark Mode Toggled', { mode: dark ? 'light' : 'dark' });
    if (dark) {
      localStorage.setItem("theme", "light");
      //dispatch an event to update the theme
      window.dispatchEvent(new Event("storage"));
      document.documentElement.classList.remove("dark");
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      window.dispatchEvent(new Event("storage"));
    }
    setDark(!dark);
    setIsDarkMode(!dark);
  };

  useEffect(() => {
    const theme = localStorage.getItem("theme");
    if (theme === "dark") {
      setDark(true);
      setIsDarkMode(true);
    }
  }, []);

  return (
    <button
      ref={ref}
      className="dbutton flex items-center gap-v3-xs py-[12px] px-v3-sm text-v3-black-max text-v3-h9 font-medium tracking-tight hover:text-v3-purple-primary rounded-v3-xxs w-full"
      onClick={() => darkModeHandler()}
    >
      {dark ? <SunIcon /> : <MoonIcon />}
      {dark ? <span>Lights On</span> : <span>Lights Off</span>}
    </button>
  );
});

DDarkModeSelector.displayName = "DDarkModeSelector";

export default DDarkModeSelector;

